import { Mic, Square, Loader2 } from "lucide-react";

const fmtTime = (ms) => {
  const s = Math.floor(ms / 1000);
  return `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
};

export const RecorderPanel = ({ state, elapsed, busy, mimeType, error, onStart, onStop }) => {
  const recording = state === "recording";
  return (
    <section data-testid="recorder-panel" className="rounded-xl border border-zinc-800 bg-[#121215] p-6 flex flex-col items-center gap-5">
      <div className="w-full flex items-center justify-between">
        <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-zinc-500">Grabador de voz</span>
        <span data-testid="recorder-mime" className="font-mono text-[10px] text-cyan-400 bg-zinc-900 border border-zinc-800 px-2 py-0.5 rounded">
          {mimeType === null ? "sin soporte" : mimeType || "formato por defecto"}
        </span>
      </div>
      <div data-testid="recorder-timer" className={`font-mono text-5xl font-black tabular-nums tracking-wider ${recording ? "text-red-400" : "text-zinc-100"}`}>
        {fmtTime(elapsed)}
      </div>
      <button
        data-testid={recording ? "stop-audio-btn" : "record-audio-btn"}
        onClick={recording ? onStop : onStart}
        disabled={busy}
        aria-label={recording ? "Detener" : "Grabar"}
        className={`relative w-24 h-24 rounded-full flex items-center justify-center transition-[transform,background-color] duration-200 active:scale-95 focus:outline-none focus:ring-4 focus:ring-red-500/40 disabled:opacity-50 ${recording ? "bg-zinc-100 rec-ring" : "bg-[#dc2626] hover:bg-[#ef4444]"}`}
      >
        {busy ? <Loader2 className="w-9 h-9 animate-spin text-white" /> : recording ? <Square className="w-9 h-9 text-red-600 fill-red-600" /> : <Mic className="w-10 h-10 text-white" />}
      </button>
      <p data-testid="recorder-status" className="font-display uppercase tracking-wider text-sm text-zinc-400">
        {busy ? "Procesando…" : recording ? "Grabando · toca para detener" : "Toca para grabar (máx. 3 min)"}
      </p>
      {error && <p data-testid="recorder-error" className="text-xs text-red-400 text-center">{error}</p>}
    </section>
  );
};
